<label [for]="field.attributes.id">
  {{ label }}
  @if (isRequired && !isEmpty) {
  <span>*</span>
  } @if (notes) {
  <icon type="info-circle-fill" matTooltip="{{ notes }}"> </icon>
  }
</label>
